export class Aviso {
  id!: number;
  titulo!: string;
  mensagem!: string;
  dataAgendamento!: Date | string;
  status!: string;
  criadoPor!: number;

  usuarios!: number[];
  pessoas!: number[];
  grupos!: number[];
  empresas!: number[];

  totalEntregues!: number;
  totalVinculados!: number;
}
